module.exports = __webpack_public_path__ + "static/lframe-travel-gem-nz-34cb238d4ab630b5f07d4614ac6a3d39.png";